import React from 'react';

function PrivacyPolicy() {
  return (
    <section className="privacy-policy section-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="cont">
              <h3 className="mb-20">
                Privacy Policy – <span className="fw-200">Bizdoc</span>
              </h3>
              <p>
                At Bizdoc, your privacy is our priority. We are committed to safeguarding the personal information you share with us while using our website (www.bizdoc.ae) or our services, including business setup in UAE, PRO services, visa assistance, document attestation, Golden Visa UAE services, family visa services, legal support, tax & compliance, and bank account opening in UAE.
              </p>
              <p>
                This Privacy Policy explains how we collect, use, and protect your personal data in compliance with UAE laws and international best practices.
              </p>

              <h4 className="mt-30">1. Information We Collect</h4>
              <p>
                We may collect the following types of information:
              </p>
              <ul className="mb-30 about-us-li">
                <li><strong>Personal Details:</strong> Name, email address, phone number, nationality, and identification documents (for visa, company setup, or legal processes).</li>
                <li><strong>Business Information:</strong> Company name, trade license, shareholder details, and incorporation documents.</li>
                <li><strong>Financial Information:</strong> Only where necessary for services like bank account opening in UAE.</li>
                <li><strong>Website Usage Data:</strong> IP address, browser type, device information, and cookies for analytics and security.</li>
              </ul>

              <h4 className="mt-20">2. How We Use Your Information</h4>
              <p>
                We use the information collected to:
              </p>
              <ul className="mb-30 about-us-li">
                <li>Provide business setup services in UAE and related corporate solutions.</li>
                <li>Process visa applications, including family visa services and Golden Visa UAE applications.</li>
                <li>Coordinate document attestation, PRO services, and legal support.</li>
                <li>Assist with bank account opening in UAE and compliance requirements.</li>
                <li>Improve website functionality and user experience.</li>
                <li>Communicate updates, service reminders, or promotions (with your consent).</li>
              </ul>

              <h4 className="mt-20">3. Sharing of Information</h4>
              <p>
                We do not sell or trade your data. We may share your information with:
              </p>
              <ul className="mb-30 about-us-li">
                <li>UAE government departments (for approvals, visas, and licensing).</li>
                <li>Banking institutions (for account opening support).</li>
                <li>Legal and compliance authorities (where required by law).</li>
                <li>Trusted third-party service providers who assist us in delivering our services.</li>
              </ul>

              <h4 className="mt-20">4. Data Security</h4>
              <p>
                We apply strict security measures to protect your data from unauthorized access, misuse, or disclosure. Sensitive data is stored securely and shared only when required by law or for service delivery.
              </p>

              <h4 className="mt-20">5. Your Rights</h4>
              <p>
                As a client, you have the right to:
              </p>
              <ul className="mb-30 about-us-li">
                <li>Access and review the personal data we hold about you.</li>
                <li>Request correction or deletion of inaccurate or unnecessary data.</li>
                <li>Opt out of receiving marketing communications.</li>
              </ul>

              <h4 className="mt-20">6. Cookies & Tracking</h4>
              <p>
                Our website uses cookies to enhance browsing, analyze traffic, and personalize content. You can disable cookies through your browser settings, though some features may not function properly.
              </p>

              <h4 className="mt-20">7. Updates to Privacy Policy</h4>
              <p>
                We may update this policy periodically to reflect legal or operational changes. Please review it regularly for the latest updates.
              </p>

              <h4 className="mt-20">8. Contact Us</h4>
              <p>
                For questions about this Privacy Policy or your personal data, contact us at:
              </p>
              <p className="mb-30">
                📧 <a href="mailto:info@bizdoc.ae" className="main-color">info@bizdoc.ae</a> | 📞 <a  className="main-color">+971 4 570 7920 </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;